export * from './card_brand_to_component'

export const isMobile = () => {
  return navigator.userAgent.match(/iPhone|Android.+Mobile/)
}

export const isIOS = () => {
  return navigator.userAgent.match(/iPhone/)
}
